<template>
    <div class="qrcode-card-c">
    <img :src="qrimageUrl" alt="" class="code-img">
    <div class="desc-c">
        <span class="title">{{title}}</span>
        <div class="price" v-if="price">{{price}}</div>
        <span class="tag" v-if="tagName">{{tagName}}</span>
    </div>
    <div style="clear:both"></div>
    </div>
</template>

<script>

export default {
	name: "external-poster",
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    computed: {
        fields() {
            return this.cardInfo?.fields || {}
        },
        xmlData() {
            return JSON.parse(this.fields?.xmljson)
        },
        qrCodeData() {
            return this.xmlData?.xml?.position?.[0]
        },
        qrimageUrl() {
            return this.qrCodeData?.qrimageUrl
        },
        tagName() {
            return this.cardInfo?.useTag == 1 ? this.cardInfo?.tagName : undefined
        },
        title() {
            return this.fields?.title?.substring(0,26) || ''
        },
        price() {
            let price = this.xmlData?.xml?.productPrice || ''
            if(typeof price !== 'undefined' && price !== ''){
                price = '￥' + Number(price).toFixed(2)
            }
            return price

        },
    },
}
</script>

<style lang="less" scoped>

</style>